import React from 'react';
import CdNumberInput from '../CdNumberInput.styles';
import { IItemWithoutShowSellerProps } from './IItemProps';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import { IExistingLoanAssumedViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface IExistingLoanAssumedProps
  extends IItemWithoutShowSellerProps,
    IHasItemDataProps<IExistingLoanAssumedViewItem>,
    IHasItemEventProps<IExistingLoanAssumedViewItem> {
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent) => void;
}

export default class ExistingLoanAssumed extends React.Component<IExistingLoanAssumedProps> {
  constructor(props: IExistingLoanAssumedProps) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
    const sellerAtClosingOnChangeEvents = generateDefaultOnChangeHandler('seller_at_closing');

    return (
      <div className="cost-data__row cost-data__aligned-row">
        <span className="cost-data__content-cell cost-data__content-row-number" />
        <span className="cost-data__content-cell cost-data__content-name">
          Existing Loan(s) Assumed or Taken Subject to
        </span>
        <span className="cost-data__content-cell cost-data__content-amount">
          <CdNumberInput
            mode="currency"
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            onChange={sellerAtClosingOnChangeEvents}
            value={this.props.data.seller_at_closing}
            readOnly={!hasEditPermissions}
            debounceOnValueChange
          />
        </span>
        <span className="cost-data__content-cell cost-data__content-control" />
      </div>
    );
  }

  private onBlur(event: React.FocusEvent) {
    const { onBlur } = this.props;
    if (onBlur) {
      onBlur(event);
    }
  }

  private onFocus() {
    const { onFocus } = this.props;
    if (onFocus) {
      onFocus();
    }
  }
}
